import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Award } from 'lucide-react';
import { useLanguage } from './LanguageContext';
const valueImages = ['https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1666214280557-f1b5022eb634?auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&w=800&q=80'];
const thumbImages = ['https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?auto=format&fit=crop&w=200&q=80', 'https://images.unsplash.com/photo-1666214280557-f1b5022eb634?auto=format&fit=crop&w=200&q=80', 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?auto=format&fit=crop&w=200&q=80', 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=200&q=80', 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&w=200&q=80'];
export function WhyChooseUs() {
  const {
    t
  } = useLanguage();
  const [active, setActive] = useState(0);
  const values = [{
    title: t('why.v1.title'),
    desc: t('why.v1.desc')
  }, {
    title: t('why.v2.title'),
    desc: t('why.v2.desc')
  }, {
    title: t('why.v3.title'),
    desc: t('why.v3.desc')
  }, {
    title: t('why.v4.title'),
    desc: t('why.v4.desc')
  }, {
    title: t('why.v5.title'),
    desc: t('why.v5.desc')
  }];
  return <section id="por-que-elegirnos" className="py-24 md:py-32 bg-bodyon-surface overflow-hidden" data-id="element-350">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-351">
        {/* Top Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16" data-id="element-352">
          <div data-id="element-353">
            <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-gray-300 mb-4" data-id="element-354">
              <Award className="w-3.5 h-3.5 text-gray-400" data-id="element-355" />
              <span className="text-gray-500 font-medium tracking-[0.2em] uppercase text-xs" data-id="element-356">
                {t('why.badge')}
              </span>
            </div>
            <h2 className="font-heading font-bold text-4xl md:text-5xl lg:text-[3.5rem] text-bodyon-teal-dark leading-tight max-w-xl" data-id="element-357">
              {t('why.heading')}
            </h2>
          </div>
          <p className="text-gray-500 text-lg max-w-md leading-relaxed lg:text-right" data-id="element-358">
            {t('why.subtitle')}
          </p>
        </motion.div>

        {/* Three Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.2fr_1fr] gap-6 lg:gap-8 min-h-[520px]" data-id="element-359">
          {/* Left Column: Values List */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col justify-between" data-id="element-360">
            <div data-id="element-361">
              <div className="flex items-center justify-between mb-6" data-id="element-362">
                <span className="text-bodyon-teal text-sm font-semibold" data-id="element-363">
                  {t('why.listLabel')}
                </span>
                <span className="text-bodyon-teal text-sm font-semibold tabular-nums" data-id="element-364">
                  {String(active + 1).padStart(2, '0')}/
                  {String(values.length).padStart(2, '0')}
                </span>
              </div>

              <div className="flex flex-col" data-id="element-365">
                {values.map((value, index) => <div key={index} className="relative" data-id="element-366">
                    <button onClick={() => setActive(index)} onMouseEnter={() => setActive(index)} className={`w-full text-left py-4 border-t border-gray-200 transition-all duration-300 ${active === index ? 'text-bodyon-teal-dark font-bold text-xl md:text-2xl' : 'text-gray-400 font-medium text-lg md:text-xl hover:text-gray-600'}`} data-id="element-367">
                      {value.title}
                    </button>

                    {/* Small tilted thumbnail on active */}
                    <AnimatePresence data-id="element-368">
                      {active === index && <motion.div initial={{
                    opacity: 0,
                    scale: 0.8,
                    rotate: -8
                  }} animate={{
                    opacity: 1,
                    scale: 1,
                    rotate: -6
                  }} exit={{
                    opacity: 0,
                    scale: 0.8,
                    rotate: -8
                  }} transition={{
                    duration: 0.3
                  }} className="absolute -right-2 top-1/2 -translate-y-1/2 w-20 h-24 rounded-lg overflow-hidden shadow-lg border-2 border-white z-10 hidden md:block" data-id="element-369">
                          <img src={thumbImages[index]} alt="" className="w-full h-full object-cover" data-id="element-370" />
                        </motion.div>}
                    </AnimatePresence>
                  </div>)}
              </div>
            </div>

            <motion.a href="https://wa.me/" target="_blank" rel="noopener noreferrer" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="inline-flex items-center gap-4 mt-8 bg-bodyon-teal-dark text-white pl-6 pr-2 py-2 rounded-full text-sm font-semibold hover:bg-bodyon-teal transition-colors w-fit group" data-id="element-371">
              {t('cta.schedule')}
              <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center group-hover:bg-white group-hover:text-bodyon-teal-dark transition-all duration-700 ease-out" data-id="element-372">
                <ArrowRight className="w-4 h-4" data-id="element-373" />
              </div>
            </motion.a>
          </motion.div>

          {/* Center Column: Large Image */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="relative rounded-3xl overflow-hidden bg-gray-100 min-h-[400px] lg:min-h-0" data-id="element-374">
            <AnimatePresence mode="wait" data-id="element-375">
              <motion.img key={active} src={valueImages[active]} alt={values[active].title} initial={{
              opacity: 0,
              scale: 1.05
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.95
            }} transition={{
              duration: 0.5
            }} className="absolute inset-0 w-full h-full object-cover" data-id="element-376" />
            </AnimatePresence>
          </motion.div>

          {/* Right Column: Teal Description Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-bodyon-teal-dark rounded-3xl p-8 lg:p-10 flex flex-col justify-between text-white" data-id="element-377">
            <AnimatePresence mode="wait" data-id="element-378">
              <motion.div key={active} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} transition={{
              duration: 0.3
            }} data-id="element-379">
                <p className="text-2xl md:text-3xl font-heading font-bold leading-snug" data-id="element-380">
                  {values[active].desc}
                </p>
              </motion.div>
            </AnimatePresence>

            <div className="flex flex-wrap gap-2 mt-10" data-id="element-381">
              {values.map((value, index) => <button key={index} onClick={() => setActive(index)} className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${active === index ? 'bg-white text-bodyon-teal-dark' : 'bg-white/20 text-white hover:bg-white/30'}`} data-id="element-382">
                  {value.title}
                </button>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}